import mapboxgl from "mapbox-gl";
import CONSTANTS from "./constants";

export function delimitedNumbers(value) {
  if (typeof value !== "number") {
    try {
      // eslint-disable-next-line no-param-reassign
      value = parseInt(value, 10);
    } catch {
      return value;
    }
  }
  return value.toLocaleString();
}

/**
 * Function which is used to map value present in one range to another
 * @param {*} value Value which needs to be mapped
 * @param {*} leftMin Min value of first range
 * @param {*} leftMax Max value of first range
 * @param {*} rightMin Min value of second range
 * @param {*} rightMax Max value of second range
 */
export function normalizeValue(value, leftMin, leftMax, rightMin, rightMax) {
  // Handles the scenario when list contains single distinct element
  if (leftMin === leftMax) {
    // In case that element is not zero, then assigning it max value of list to be mapped
    // In case that element is zero, then assigning it min value of list to be mapped
    return leftMin ? rightMax : rightMin;
  }
  const leftSpan = leftMax - leftMin;
  const rightSpan = rightMax - rightMin;
  const valueScaled = parseFloat(value - leftMin) / parseFloat(leftSpan);
  return Math.ceil(rightMin + valueScaled * rightSpan);
}

/** Function which is used to generate the message to be displayed in popup while hovering over map
 * @param {*} featureData Feature data associated with the layer
 * @param {*} layer Layer for which message neeeds to be generated
 */
export function generatePopUpMessage(featureData, layer = CONSTANTS.LAYERS.STATE) {
  let state = null;
  if (layer === CONSTANTS.LAYERS.STATE) {
    state = featureData.properties.state;
  } else {
    state = featureData.properties.name;
  }
  const visits = delimitedNumbers(featureData.state.visit);
  const locations = delimitedNumbers(featureData.state.location);
  return `<strong>${state}<br> Visits: ${visits}<br> Locations: ${locations}</strong>`;
}

export function getBoundsFromGeometryCoordinates(coordinates, bounds) {
  if (!Array.isArray(coordinates)) return;

  if (typeof coordinates[0] === "number") {
    bounds.extend(new mapboxgl.LngLat(coordinates[0], coordinates[1]));
  } else if (Array.isArray(coordinates[0])) {
    coordinates.map((coord) => {
      getBoundsFromGeometryCoordinates(coord, bounds);
      return coordinates;
    });
  }
}

/**
 * Function which is used to implement the `debounce` functionality in order to implement rate-limiting
 * @param {*} func Input function which needs to be wrapped for rate-limiting
 * @param {*} delay Minimum interval between two successive calls after which function needs to be executed
 */
export function debounce(func, delay) {
  let debounceTimer;
  return (...argument) => {
    const context = this;
    const args = argument;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
}

// Used to hold value of style class for spinner position
let spinnerPosition = {};

/**
 * Function which is used to update the value of `spinnerPosition` based on map paddingObject
 * @param {*} paddingObject Object containing the value of map padding
 */
export function setSpinnerPosition(paddingObject) {
  const cssStyle = {
    position: "relative",
  };
  Object.keys(paddingObject).forEach(function iterateObject(key) {
    cssStyle[key] = paddingObject[key] / 2;
  });
  spinnerPosition = { ...cssStyle };
}

/**
 * Function which is used to retrieve the value of `spinnerPosition`
 */
export function getSpinnerPosition() {
  return spinnerPosition;
}
